// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import { BoardsDashboardSelector } from 'common/widgets/dashboard-selector/presets';
import { SectionItem } from 'common/components/items-menu/types';
import { Directions } from 'common/components/drop-menu/types';
import { ProjectSelectorEl } from 'common/widgets/project-selector';
import { TooltipAttrs } from 'common/components/tooltip/types';
import type { DashboardSelectorController } from 'common/report/controllers/dashboard-selector-controller';
import { Translatable } from 'common/i18n';

/**
 * Returns a SectionItem object compatible with the items-menu component
 */
export function getBoardsDashboardSectionItem(_ref: {
  label: Translatable;
  name: string;
  recentDashboardIds: number[];
  placeholder: string;
  quickCreateSaveDashboardCopy: string;
  dashboardController: DashboardSelectorController;
  enableNestedDashboardsRestrictions: boolean;
  icon?: string;
  direction?: Directions;
  offset?: number;
  fixedParent?: boolean;
  showProjectSelector?: boolean;
  showMoveOutButton?: boolean;
  hideDashboardList?: boolean;
  excludedDashboards?: number[];
  currentDashboardHierarchyTreeHeight?: number;
  descendantDashboardIds?: Set<number>;
  tooltip?: TooltipAttrs;
  detailedExplainCopy?: {
    title: Translatable;
    description: Translatable;
  };
}): SectionItem {
  let {
    label,
    name,
    recentDashboardIds,
    placeholder,
    quickCreateSaveDashboardCopy,
    dashboardController,
    icon,
    direction,
    offset,
    fixedParent,
    showProjectSelector,
    showMoveOutButton,
    hideDashboardList,
    excludedDashboards,
    currentDashboardHierarchyTreeHeight,
    descendantDashboardIds,
    tooltip,
    enableNestedDashboardsRestrictions,
    detailedExplainCopy
  }: {
    label: Translatable;
    name: string;
    recentDashboardIds: number[];
    placeholder: string;
    quickCreateSaveDashboardCopy: string;
    dashboardController: DashboardSelectorController;
    enableNestedDashboardsRestrictions: boolean;
    icon?: string;
    direction?: Directions;
    offset?: number;
    fixedParent?: boolean;
    showProjectSelector?: boolean;
    showMoveOutButton?: boolean;
    hideDashboardList?: boolean;
    excludedDashboards?: number[];
    currentDashboardHierarchyTreeHeight?: number;
    descendantDashboardIds?: Set<number>;
    tooltip?: TooltipAttrs;
    detailedExplainCopy?: {
      title: Translatable;
      description: Translatable;
    };
  } = _ref;
  direction || (direction = Directions.Right);
  return {
    label,
    name,
    icon,
    tooltip,
    actionsRenderer: () => <SvgIconEl attrs={{
      icon: "caret-right"
    }} />,
    subMenuRenderer: onValueSelected => <div style={fixedParent && {
      position: "fixed",
      height: "41px"
    }}>
        <BoardsDashboardSelector recentDashboardIds={recentDashboardIds} placeholder={placeholder} quickCreateSaveDashboardCopy={quickCreateSaveDashboardCopy} dashboardController={dashboardController} handleDashboardSelected={ev => {
        ev.preventDefault();
        ev.stopPropagation();
        onValueSelected(ev.detail.id, ev.detail);
      }} direction={direction} offset={offset} showProjectSelector={showProjectSelector} hideDashboardList={hideDashboardList} showMoveOutButton={showMoveOutButton} enableNestedDashboardsRestrictions={enableNestedDashboardsRestrictions} excludedDashboards={excludedDashboards} currentDashboardHierarchyTreeHeight={currentDashboardHierarchyTreeHeight} descendantDashboardIds={descendantDashboardIds} detailedExplainCopy={detailedExplainCopy} />
      </div>
  };
}
export function getProjectSelectorSectionItem(_ref2: {
  label: Translatable;
  name: string;
  placeholder: Translatable;
  quickCreateSaveDashboardCopy: Translatable;
  icon?: string;
  direction?: Directions;
}): SectionItem {
  let {
    label,
    name,
    placeholder,
    quickCreateSaveDashboardCopy,
    icon,
    direction
  }: {
    label: Translatable;
    name: string;
    placeholder: Translatable;
    quickCreateSaveDashboardCopy: Translatable;
    icon?: string;
    direction?: Directions;
  } = _ref2;
  direction || (direction = Directions.Right);
  return {
    label,
    name,
    icon,
    actionsRenderer: () => <SvgIconEl attrs={{
      icon: "caret-right"
    }} />,
    subMenuRenderer: (onValueSelected, itemsMenuEl) => <ProjectSelectorEl params={{
      searchPlaceholder: placeholder,
      submitCopy: quickCreateSaveDashboardCopy,
      positionParent: itemsMenuEl,
      direction,
      offset: 2
    }} on={{
      select: (ev: CustomEvent) => {
        ev.preventDefault();
        ev.stopPropagation();
        onValueSelected(undefined, ev.detail);
      }
    }} />
  };
}